<form [formGroup]="expenseitemForm" (ngSubmit)="onSubmit()">
    <p-card>
        <div class="formgrid grid">
            <div class="field col-12 pt-3">
                <h4>Line Items</h4>
                <rc-generic-button label="Add Line Item" iconImg="plus" borderStyle="outline"
                    [classes]="['mb-3']" (click)="openLineItemDialog()" />

                <p-table [value]="lineItems" responsiveLayout="scroll" styleClass="datatable-sm first-col-border last-col-border">
                    <ng-template pTemplate="header">
                        <tr>
                            <th></th>
                            <th>Amount</th>
                            <th>Event</th>
                            <th>Account</th>
                            <th>Actions</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-item>
                        <tr>
                            <td>{{ item.lineNumber }}</td>
                            <td>{{ item.lineItem_RequestedAmount }}</td>
                            <td>{{ item.eventDescription }}</td>
                            <td>{{ item.glAccountDisplayText }}</td>
                            <td style="white-space: nowrap;">
                                <rc-generic-button 
                                    label="Edit"
                                    iconImg="cog"
                                    iconColor="teal-light"
                                    [isIconOnly]="true"
                                    (click)="editLineItemDialog(item)" />
                                <rc-generic-button 
                                    label="Delete"
                                    iconImg="trash"
                                    iconColor="red-light"
                                    [isIconOnly]="true"
                                    (click)="deleteLineItem(item)" />
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>

            <!-- Right Column: Invoice Attachments -->
            <div class="field col-12 pt-3">
                <h4>Invoice Attachments</h4>
                <rc-generic-button 
                    label="Upload File" 
                    iconImg="upload" 
                    borderStyle="outline"
                    [classes]="['mb-3']" 
                    (click)="openLineItemAttachmentDialog()" />

                <p-table [value]="attachments" responsiveLayout="scroll" styleClass="datatable-sm last-col-border ">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Number</th>
                            <th>File Name</th>
                            <th>Actions</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-attachment>
                        <tr>
                            <td>{{ attachment.attachmentId }}</td>
                            <td>{{ attachment.fileName }}</td>
                            <td class="text-left">
                                <rc-generic-button 
                                    label="Delete"
                                    iconImg="trash"
                                    iconColor="red-light"
                                    [isIconOnly]="true"
                                    (click)="deleteLineAttachmentItem(attachment)" />
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
            <div class="col-12">
                <p><i>Note: Line Items are required to submit request for payment</i></p>
            </div>
        </div>
    </p-card>
    <p-card>
        <p-button [outlined]="true" severity="secondary" label="Previous" (onClick)="prevCallback.emit()" />
        <p-button type="submit" label="Next" severity="secondary" />
    </p-card>
</form>


<!-- Add/Edit line item MODAL -->
<p-dialog [(visible)]="lineItemDialog" 
    header="{{ isEdit ? 'Edit Line Item' : 'Add Line Item' }}"
    [modal]="true" 
    [maximizable]="true"
    styleClass="p-dialog-static p-dialog-md fadeinright animation-duration-300">

    <ng-container *ngIf="lineItemDialog">
        <p-card >
            <form [formGroup]="expenselineitemForm">
                <input type="hidden" formControlName="requestId" />
                <input type="hidden" formControlName="lineItemId" />
                <input type="hidden" formControlName="lineItem_CampaignId" />

                <div class="formgrid grid">
                    <div class="col-12 sm:col-6 field">
                        <label for="lineNumber">Line Number</label>
                        <input type="text" pInputText name="lineNumber" formControlName="lineNumber" readonly />
                    </div>
                    <div class="col-12 sm:col-6 field">
                        <label for="lineItem_RequestedAmount" class="field-label required">Requested Amount</label>
                        <input
                            pInputText
                            id="lineItem_RequestedAmount"
                            formControlName="lineItem_RequestedAmount"
                            type="text"
                            class="form-control"
                            (input)="onAmountInput($event)"
                            placeholder="Enter requested amount"
                            required
                        />
                        <small *ngIf="expenselineitemForm.get('lineItem_RequestedAmount')?.invalid && expenselineitemForm.get('lineItem_RequestedAmount')?.touched" class="p-error">Requested Amount is required.</small>
                    </div>
                    <div class="col-12 sm:col-6 field">
                        <label for="event">Event</label>
                        <p-autoComplete id="event" formControlName="event" [suggestions]="eventSuggestions"
                        (completeMethod)="searchEvent($event.query)" (onSelect)="onEventSelect($event)"
                        placeholder="Type to Search"></p-autoComplete>
                    </div>
                    <div class="col-12 sm:col-6 field">
                        <label for="account" class="field-label required">GL</label>
                        <p-autoComplete id="account" formControlName="account" [suggestions]="accountSuggestions" (completeMethod)="searchAccount($event.query)" (onSelect)="onAccountSelect($event)" placeholder="Type to Search"></p-autoComplete>
                        <small *ngIf="expenselineitemForm.get('account')?.invalid && expenselineitemForm.get('account')?.touched" class="p-error">GL is required.</small>
                    </div>
                </div>
            </form>
        </p-card>
    </ng-container>
    <ng-template pTemplate="footer">
        <p-button type="button" label="Cancel" [text]="true" (onClick)="onCancel()" />
        <p-button type="submit" label="Save" (onClick)="saveLineItem(isEdit)" />
    </ng-template>
</p-dialog>

<!-- Add Attachemnts MODAL -->
<p-dialog [(visible)]="lineAttachmentDialog" 
    header="Add Attachments" 
    [modal]="true" 
    styleClass="p-dialog-static p-dialog-md fadeinright animation-duration-300">

    <ng-container *ngIf="lineAttachmentDialog">
        <div class="field">
            <label for="fileUpload" class="mb-3">Upload Files</label>
            <p-fileUpload 
                name="files[]" 
                customUpload="true" 
                multiple="true" 
                [auto]="false" 
                [showUploadButton]="true"
                [showCancelButton]="true" 
                (uploadHandler)="onFileUpload($event)"
                accept=".doc,.docx,.pdf,.csv,.xls,.xlsx,.png,.jpg,.jpeg,.eml,.msg" 
                [maxFileSize]="5000000" />
        </div>
    </ng-container>
    <ng-template pTemplate="footer">
        <p-button type="button" label="Cancel" (onClick)="onCancel()" />
    </ng-template>
</p-dialog>
